Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.FilterView extends Backbone.View
  initialize: ({filter}) ->
    @filter = filter

  applyFilter: =>
    newValues = @_getSelectedValues()
    @filter.setValues(newValues)
    @trigger 'filters:apply', @filter

  _getSelectedValues: ->
    throw new Error 'Not implemented'
